module.exports = __webpack_public_path__ + "img/pole-status-green.26cfcdac.png";